import React from "react";
import { Card, CardActions, CardContent, SxProps, Theme, Typography } from "@mui/material";

export interface ICardDisplayProps {
  title?: string;
  titleRight?: React.ReactNode;
  contents?: React.ReactNode;
  actions?: React.ReactNode;
  sx?: SxProps<Theme>;
  onClick?: React.MouseEventHandler<HTMLElement>;
  ariaLabel?: string;
}

const CardsDisplay: React.FC<ICardDisplayProps> = ({ title, titleRight, contents, actions, sx, onClick, ariaLabel }) => {
  const isClickable = typeof onClick === "function";

  return (
    <Card
      variant="outlined"
      component={isClickable ? "button" : "div"}
      type={isClickable ? "button" : undefined}
      onClick={onClick}
      aria-label={isClickable ? (ariaLabel ?? title) : undefined}
      sx={{
        boxShadow: "var(--shadow-card)",
        ...(isClickable && {
          width: "100%",
          margin: 0,
          padding: 0,
          textAlign: "left",
          background: "transparent",
          color: "inherit",
          cursor: "pointer",
          '&:focus-visible': {
            outline: '2px solid var(--ring)',
            outlineOffset: '4px',
          },
        }),
        ...sx,
      }}
    >
      <CardContent style={{ padding: 24 }}>
        {title != null && (
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
            <Typography
              variant="body2"
              sx={{ fontWeight: 700, color: "var(--muted-foreground)" }}
            >
              {title}
            </Typography>
            {titleRight}
          </div>
        )}
        {contents ? contents : ""}
      </CardContent>
      {actions && <CardActions>{actions}</CardActions>}
    </Card>
  );
};

export default CardsDisplay;
